const invitations = {
  pageName: 'הזמנות',

  toast: {
    error: {
      default: 'לא ניתן להשלים את הפעולה.',
    },
    success: {
      delete: {
        default: 'ההזמנה/ות נמחקו בהצלחה',
      },
      resend: {
        default: 'ההזמנה/ות נשלחו מחדש בהצלחה.',
      },
      create: {
        default: 'הצלחה! ההזמנה נשלחה בהצלחה.',
      }
    },
  },

  table: {
    headers: {
      status: 'סטטוס',
      email: 'אימייל',
      role: 'תפקיד',
      invitedBy: 'הוזמן על ידי',
    },
    actions: {
      delete: 'מחק',
      resend: 'שלח מחדש',
    },
    filters: {
      status: 'סטטוס',
    }
  },

  form: {
    headers: {
      personalDetails: 'פרטים אישיים',
      roles: 'תפקידי משתמש',
    },
    fields: {
      firstName: 'שם פרטי',
      lastName: 'שם משפחה',
      name: 'שם',
      phone: 'טלפון',
      email: 'אימייל',
      role: 'תפקיד',
      site: 'אתר',
    },
    select: 'בחר',
    buttons: {
      addAccess: 'הוסף אתר',
      sendInvitation: 'שלח הזמנה',
    },
  },

  deleteModal: {
    header: 'מחק הזמנות',
    body: 'אתה עומד למחוק {{num}} הזמנות.',
  },

  resendModal: {
    header: 'שלח הזמנות מחדש',
    body: 'אתה עומד לשלוח מחדש {{num}} הזמנות.',
  },

  inviteModal: {
    header: 'הזמן משתמש',
    description: {
      new: 'אנא הזן כתובת אימייל ובחר תפקידים מועדפים.',
      existing: 'אנא בחר אתרים ותפקידים מועדפים.',
    },
  },
  
  status: {
    pend: 'ממתין',
    accepted: 'התקבל',
    expired: 'פג תוקף',
  },

  isCompanyAdmin: 'מנהל חברה',
};

export default invitations;
